module.exports = __webpack_public_path__ + "static/media/no-img-news.f585e158.jpg";